import { inject, Injectable } from '@angular/core';
import { RoutingService } from '../../../core/services/routing.service';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class LidDepartmentService extends SingleDepartmentService {
  private routerService = inject(RoutingService);
  private _departmentId: number;

  set departmentId(value: number) {
    this._departmentId = value;
  }

  get departmentId(): number {
    return this._departmentId;
  }

  readonly NAME = 'Lids';
  departmentName = 'Lids';

  stageName: string;

  constructor() {
    super();
    this.stageName = this.routerService.lastUrlComponent;
  }

  defaultRoutes(roles: string[]): boolean {
    if (
      roles.includes('Lid') ||
      roles.includes('LidViewer') ||
      roles.includes('LidSupervisor') ||
      roles.includes('LidOperator') ||
      roles.includes('LidLeader') ||
      roles.includes('LidChief') ||
      roles.includes('LidEngineer')
    ) {
      this.router.navigate(['/sb/lids/scheduler']);
      return true;
    }
    if (roles.includes('LidLabel')) {
      this.router.navigate(['/sb/lids/packing-box']);
      return true;
    }
    return false;
  }
}
